// extracted by mini-css-extract-plugin
export var cardSelected = "_fw-2";
export var image = "_fw-1";
export var table = "_fw-0";